import { TENANTS } from "../../../constants"
import { loc } from "../../../core/utils"
import Optin from "../../../form/Optin"
import { useLocalStorageServicePack } from "../../../hooks"
import { withPackContext } from "../../hoc/withPackContext"
import { withTunnelDataContext } from "../../hoc/withTunnelDataContext"
import React, { useMemo } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import * as FinalForm from "react-final-form"

const Submit = ({ tunnelData, onSetStep, packContext, selectedPack, setPackContext }) => {
  const { packs } = packContext
  const { setLocalStorageServicePack } = useLocalStorageServicePack()
  const { servicePageOptins } = tunnelData

  const insuranceExists = useMemo(() => checkInsuranceExists(packs), [packs])

  const submit = () => {
    const saveAndOnSetStep = () => {
      setLocalStorageServicePack(selectedPack)
      onSetStep()
    }

    insuranceExists && !selectedPack?.servicePackDTO?.hasInsuranceIncluded && !TENANTS.SAMSUNG_NL
      ? setPackContext({ showModal: true })
      : saveAndOnSetStep()
  }
  return (
    <FinalForm.Form
      onSubmit={submit}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          {tunnelData.data?.order?.financerType !== "PFLOC" &&
            tunnelData.tenant !== "samsung_pt" &&
            servicePageOptins && <Optins tunnelData={tunnelData} options={servicePageOptins?.genericOptins} />}
          {tunnelData.data?.order?.financerType !== "PFLOC" && selectedPack?.servicePackDTO?.hasInsuranceIncluded && (
            <Optins tunnelData={tunnelData} options={servicePageOptins?.expensiveServicePackAdditionalOptins} />
          )}
          {tunnelData.data?.order?.financerType !== "PFLOC" &&
            !selectedPack?.servicePackDTO?.hasInsuranceIncluded &&
            insuranceExists && (
              <Optins tunnelData={tunnelData} options={servicePageOptins?.cheapServicePackAdditionalOptins} />
            )}
          <Row className="footer-fixed">
            <BackToShopButton tunnelData={tunnelData} />
            <ValidatepButton />
          </Row>
        </Form>
      )}
    />
  )
}

const BackToShopButton = ({ tunnelData }) => {
  return (
    <Col lg={{ span: 3, order: 1 }} md={{ span: 4, order: 1 }} xs={{ span: 12, order: 2 }} className="mr-auto">
      <Button
        href={tunnelData?.tenant === TENANTS.PROXY_CYCLE ? tunnelData?.serviceReturnShopUrl : tunnelData?.shopUrl}
        variant="outline-primary"
        className="ico-back-small-before"
      >
        {loc`Back to shop`}
      </Button>
    </Col>
  )
}

const ValidatepButton = () => {
  return (
    <Col lg={{ span: 3, order: 2 }} md={{ span: 4, order: 2 }} xs={{ span: 12, order: 1 }} className="align-item-end">
      <Button id="validate-button" variant="success" type="submit">
        {loc`Validate`}
      </Button>
    </Col>
  )
}

const Optins = ({ options, tunnelData }) => {
  return options?.map((label) => {
    return (
      <Optin
        tunnelData={tunnelData}
        optin={{ code: label, label: label, type: "checkbox", required: true }}
        key={label}
      />
    )
  })
}

const checkInsuranceExists = (packs) => {
  return packs && packs?.filter((selectedPack) => selectedPack?.servicePackDTO?.hasInsuranceIncluded).length !== 0
}

export default withTunnelDataContext(withPackContext(Submit))
